import {createDeviceToken} from '../common/BackendConnections'
import {useCallback, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import { getFacilitatorAppURL } from '../common/Backend';

const FacilitatorAppPage = () => {
  const [tokenReceived, setTokenReceived] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  let { sessionId } = useParams();

  const faUrl = getFacilitatorAppURL();

  const addListener = useCallback((token) => {
    console.log("FA addListener config: ", token, faUrl);
    // ****** WARNING WARNING WARNING ******
    // Debug Mode disables safety checks for testing.
    // Ensure this FALSE in production!
    const debugMode = true;
    if (debugMode){
      console.warn("\n***********\n* WARNING * DEBUG MODE ENABLED. THIS IS NOT SAFE!\n***********");
    }
    // *************************************

    /**
     * Add an event listener to hear requests from the embedded iframe
     *
     * Message format will be:
     * {
     *  cmd: "getToken"
     * }
     **/
    window.addEventListener("message", function(event) {
      // Check the origin of the message for security
      // Only accept messages that come from the FA domain
      if (event.origin !== faUrl) {
        if (! debugMode){
          return;
        }
      }

      // Validate we're responding to the right command:
      if (event.data.cmd === "getToken" && token) {
        console.log("--- PARENT: Heard request from iframe to obtain the token")

        // Send the token to the iframe:
        const iframe = document.getElementById("facilitator-app");

        // ****** WARNING WARNING WARNING ******
        // Use https://sub-fe.not4prod.com/ once tested. * allows wildcard.
        iframe.contentWindow.postMessage({ token: token }, debugMode ? "*" : faUrl);
      }
    }, false);
  }, [faUrl]);

  const fetchDeviceToken = useCallback( () => {
    createDeviceToken(sessionId).then(resonse => {
      setTokenReceived(true);
      addListener(resonse.data.access_token);
    }).catch(_ => {
      setErrorMessage('Error: no device token.')
    })
    }, [sessionId, addListener]);

  useEffect(() => {
    fetchDeviceToken();
  }, [fetchDeviceToken]);

  return (
  <div>
    {tokenReceived &&
      /*<h2 style={{marginTop: "2rem"}}>*/
      /*  Facilitator App*/
      /*</h2>*/
      <div style={{margin: "0 0 0 0", overflow: "hidden"}}>
        {/*<iframe style={{width: "80rem", height: "50rem", border: "2px solid #707070"}} title="Facilitator App" src="https://subway-dev.not4prod.com/"></iframe>*/}
          <iframe style={{width: "100vw", height: "100vh", border: 'none'}} title="Facilitator App" src={faUrl} id="facilitator-app"></iframe>
      </div>
    }
    {!tokenReceived &&
        <h2>
          {(errorMessage) ? errorMessage : "Loading..."}
        </h2>}
  </div>)
};

export default FacilitatorAppPage;
